const $ = jQuery;
const _window = $(window);
const PriceSlider = {
	findClosest(array, value) {
		return array.reduce((closest, current) =>
			Math.abs(current - value) < Math.abs(closest - value) ? current : closest
		);
	},

	init: () => {
		const select = $('select[name="attribute_pa_custom-pricing"]');
		if (select && select.length > 0) {
			const options = select.find('option');
			const initalValue = select.val();

			let steps = 0;
			let isSwiping = false;
			const values = options
				.map(function () {
					if ($(this).val() != '') {
						return parseInt($(this).val());
					}
				})
				.get()
				.sort((a, b) => a - b);
			steps = values.length;

			const sliderWrapperWrapper = $('<div class="main-price-slider" />');
			const sliderWrapper = $('<div id="price-slider" />');
			const sliderSwipe = $('<span id="price-slider-swipe" />');
			const sliderSwipeHolder = $('<span id="price-slider-holder" />');
			sliderWrapper.append(sliderSwipeHolder);
			sliderWrapper.append(sliderSwipe);
			sliderWrapperWrapper.append(sliderWrapper);

			select.after(sliderWrapperWrapper);

			const calcPosition = (e, firstStep = null) => {
				var parentPosition = sliderWrapper.offset();
				var parentWidth = sliderWrapper.width();
				const stepWidth = parentWidth / steps;
				const startPx = 25;
				const endOffsetPx = 40;
				const stepSize = (parentWidth - 50) / steps;
				let parentWidthSteps = [];
				for (let index = 1; index <= steps; index++) {
					if (index == 1) parentWidthSteps.push(25);
					else parentWidthSteps.push(index * stepSize);
				}
				console.log(parentWidthSteps);

				if (firstStep) {
					const calcPosition =
						parentWidthSteps[values.indexOf(parseInt(firstStep))];

					// const realPosition = (calcPosition / parentWidth) * 100;
					const realPosition = `calc(${startPx}px + ${
						100 - (endOffsetPx * 100) / parentWidth
					}% * 0)`;

					sliderSwipe.css(`left`, `${realPosition}`);
					sliderSwipeHolder.css(`width`, `${realPosition}`);
					for (let index = 0; index < values.length; index++) {
						const price = values[index];
						const frac = index / (steps - 1);
						const positionItem =
							index == 0
								? (30 / parentWidth) * 100
								: (((index + 1) * stepSize) / parentWidth) * 100;
						const $item = $(
							'<span class="price-item" style="left:' +
								`calc(${startPx}px + ${
									100 - (endOffsetPx * 100) / parentWidth
								}% * ${frac})` +
								';">' +
								price +
								'</span>'
						);
						sliderWrapper.append($item);
					}
					return;
				}
				const offsetPage = e.pageX;

				let position = offsetPage - parentPosition.left;
				if (position <= 0) position = 0;
				if (parentWidth + parentPosition <= position)
					position = parentWidth + parentPosition;

				const realPosition =
					(PriceSlider.findClosest(parentWidthSteps, position) / parentWidth) *
					100;
				const step = parentWidthSteps.indexOf(
					PriceSlider.findClosest(parentWidthSteps, position)
				);
        console.log(step);
        
				const frac2 = step / (steps - 1);
				const realPosition2 = `calc(${startPx}px + ${
					100 - (endOffsetPx * 100) / parentWidth
				}% * ${frac2})`;
        console.log(realPosition2);
        

				sliderSwipe.css(`left`, `${realPosition2}`);
				sliderSwipeHolder.css(`width`, `${realPosition2}`);
				select.val(values[step]).trigger('change');
			};

			calcPosition(null, initalValue);

			sliderWrapper.on('dragend click', function (e) {
				calcPosition(e);
			});
		}
	},
};
export default PriceSlider;
